import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Droplets, ArrowRight } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { Reveal, Tag } from "./Reveal";
import { ASSETS } from "../../lib/assets";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Waterproofing = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section id="waterproofing" ref={ref} className="relative bg-brand-light py-24 md:py-32 overflow-hidden" data-testid="waterproofing">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <Tag>{t.waterproofing.tag}</Tag>
            <h2 className="mt-5 font-display font-semibold text-brand-navy text-4xl sm:text-5xl leading-[1.04] [word-break:break-word]">
              {t.waterproofing.title}
            </h2>
            <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-xl">{t.waterproofing.subtitle}</p>

            <div className="mt-8 flex flex-wrap gap-3">
              {t.waterproofing.apps.map((a, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-2 rounded-full border border-brand-blue/20 bg-white px-4 py-2 text-sm text-brand-navy"
                  data-testid={`waterproofing-app-${i}`}
                >
                  <Droplets size={14} className="text-brand-azure" />
                  {a}
                </span>
              ))}
            </div>

            <button
              onClick={() => scrollTo("contact")}
              className="group mt-10 inline-flex items-center gap-2 font-condensed uppercase tracking-[0.15em] font-semibold text-white bg-brand-navy hover:bg-brand-blue transition-colors rounded-full px-7 py-4"
              data-testid="waterproofing-cta"
            >
              {t.waterproofing.cta}
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-2xl">
              <motion.img
                style={{ y, scale: 1.15 }}
                src={ASSETS.polyureaRoof}
                alt="Applicazione poliurea su tetto industriale"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-3xl" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
